<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" type="text" placeholder="Name" />
      <button
        type="button"
        *ngIf="form.get('name').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('name').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>DBA</mat-label>
      <input matInput formControlName="dba" type="text" placeholder="DBA" />
      <button
        type="button"
        *ngIf="form.get('dba').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('dba').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Tax ID</mat-label>
      <input matInput formControlName="ein" type="text" placeholder="Tax ID" />
      <button
        type="button"
        *ngIf="form.get('ein').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('ein').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Type</mat-label>
      <mat-select matInput multiple formControlName="types" placeholder="Type">
        <mat-option *ngFor="let t of brokerTypes" [value]="t.value">{{ t.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('types').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('types').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput multiple formControlName="statuses" placeholder="Status">
        <mat-option *ngFor="let s of entityStatuses" [value]="s.value">{{ s.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('statuses').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('statuses').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Pricing plan</mat-label>
      <mat-select matInput multiple formControlName="pricingPlans" placeholder="Pricing plan">
        <mat-option *ngFor="let p of brokerPricingPlans" [value]="p.value">{{ p.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('pricingPlans').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('pricingPlans').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Tier</mat-label>
      <mat-select matInput multiple formControlName="tiers" placeholder="Tier">
        <mat-option *ngFor="let t of brokerTiers" [value]="t.value">{{ t.name }}</mat-option>
      </mat-select>
      <button
        type="button"
        *ngIf="form.get('tiers').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('tiers').setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Contact email</mat-label>
      <input matInput formControlName="contactEmail" type="text" placeholder="Contact email" />
      <button
        type="button"
        *ngIf="form.get('contactEmail').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('contactEmail').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Commission email</mat-label>
      <input matInput formControlName="commissionEmail" type="text" placeholder="Commission email" />
      <button
        type="button"
        *ngIf="form.get('commissionEmail').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('commissionEmail').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Web site</mat-label>
      <input matInput formControlName="webSite" type="text" placeholder="Web site" />
      <button
        type="button"
        *ngIf="form.get('webSite').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('webSite').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Phone</mat-label>
      <input matInput formControlName="phone" type="text" placeholder="Phone" />
      <button
        type="button"
        *ngIf="form.get('phone').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('phone').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <ifc-filter-param-date-range-input
      [fc]="form.get('establishedDate')"
      [label]="'Established date'"
      (rangeSelected)="establishedDateSelected($event)"
      baseFilterItem
    ></ifc-filter-param-date-range-input>

    <ng-container *ngIf="form.get('establishedDate').value === 'custom'">
      <ifc-datepicker
        [fc]="form.get('establishedDateStart')"
        [label]="'Established date from'"
        baseFilterItem
      ></ifc-datepicker>
      <ifc-datepicker
        [fc]="form.get('establishedDateEnd')"
        [label]="'Established date to'"
        baseFilterItem
      ></ifc-datepicker>
    </ng-container>

    <ifc-filter-param-date-range-input
      [fc]="form.get('contractDate')"
      [label]="'Contract date'"
      (rangeSelected)="contractDateSelected($event)"
      baseFilterItem
    ></ifc-filter-param-date-range-input>
    <ifc-filter-param-date-range-input
      [fc]="form.get('createdOn')"
      [label]="'Created on'"
      (rangeSelected)="createdDateSelected($event)"
      baseFilterItem
    ></ifc-filter-param-date-range-input>

    <ng-container *ngIf="form.get('contractDate').value === 'custom'">
      <ifc-datepicker
        [fc]="form.get('contractDateStart')"
        [label]="'Contract date from'"
        baseFilterItem
      ></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('contractDateEnd')" [label]="'Contract date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <ng-container *ngIf="form.get('createdOn').value === 'custom'">
      <ifc-datepicker [fc]="form.get('createdOnStart')" [label]="'Created date from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('createdOnEnd')" [label]="'Created date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
